import { createTheme } from '@mui/material/styles';

// Create a simple MUI theme with custom primary & secondary colors
const theme = createTheme({
  palette: {
    primary: { main: '#b71c1c' }, // red
    secondary: { main: '#000000' }, // black
    background: { default: '#ffffff' },
    text: { primary: '#000000' }
  }
});

export default theme;
